import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../AuthContext/AuthContext';

export const ProtectedRoute = ({ children, allowedRoles }) => {
    const { isLoggedIn, userRole } = useAuth();

    if (!isLoggedIn) {
        // User not logged in, redirect to login page
        return <Navigate to="/login" />;
        // return <Navigate to="/login" />;
    } else if (allowedRoles && !allowedRoles.includes(userRole)) {
        // User logged in but does not have the required role, redirect or show not authorized
        return <Navigate to="/not-authorized" />;
    }

    return children;
};
